import { defaultHttpClient } from '../../httpClient';
import type {
  PostRecoverPasswordRequest,
  PostRecoverPasswordResponse,
} from './types';

/**
 * 비밀번호 찾기 — 인증번호를 발급
 */
export const postRecoverPassword = (params: PostRecoverPasswordRequest) => {
  return defaultHttpClient
    .request<PostRecoverPasswordResponse>({
      method: 'POST',
      url: '/api/v2/members/recover_password/',
      data: params,
    })
    .then(result => result.data);
};
